import { jsx } from "react/jsx-runtime";
import { $createParagraphNode, $getRoot, DecoratorNode } from "lexical";
import { Quote } from "../../plugins/index.js";
import { $createQuoteNode } from "./helpers.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function QuoteNode_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else QuoteNode_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
class QuoteNode extends DecoratorNode {
    static getType() {
        return 'quote-node';
    }
    static clone(node) {
        return new QuoteNode(node.__text, node.__author, node.__key);
    }
    setText(text) {
        const self = this.getWritable();
        self.markDirty();
        self.__text = text;
    }
    getText() {
        return this.__text;
    }
    setAuthor(author) {
        const self = this.getWritable();
        self.markDirty();
        self.__author = author;
    }
    getAuthor() {
        return this.__author;
    }
    createDOM() {
        const element = document.createElement('div');
        return element;
    }
    decorate(editor) {
        const handleRemove = ()=>{
            editor.update(()=>{
                const root = $getRoot();
                if (0 === root.getChildrenSize()) $createParagraphNode().select();
                else root.selectEnd();
                this.remove();
            });
        };
        const setData = (text, author)=>{
            this.setText(text);
            if (author) return void this.setAuthor(author);
            this.setAuthor('');
        };
        return /*#__PURE__*/ jsx(Quote, {
            author: this.__author,
            text: this.__text,
            editor: editor,
            setData: setData,
            remove: handleRemove
        });
    }
    updateDOM() {
        return false;
    }
    exportDOM() {
        const element = document.createElement('div');
        element.textContent = `${this.__text} — ${this.__author}`;
        return {
            element
        };
    }
    static importJSON(serializedNode) {
        return $createQuoteNode(serializedNode.text, serializedNode.author);
    }
    exportJSON() {
        return _object_spread_props(_object_spread({}, super.exportJSON()), {
            type: 'quote-node',
            version: 1,
            text: this.__text,
            author: this.__author
        });
    }
    canMergeWhenEmpty() {
        return true;
    }
    getTextContent() {
        return `${this.__text} ${this.__author}`;
    }
    constructor(text, author, key){
        super(key);
        this.__text = text;
        this.__author = author;
    }
}
export { QuoteNode };
